import React, { useEffect, useRef } from "react"

import { StyledListItem, StyledSubListItem } from "./styles"
import { Link, Typography, useTheme } from "@mui/material"
import { ListTextItemTypes } from "../types"
import { isValidUrl } from "../../../util"

const ListTextItem: React.FC<ListTextItemTypes> = (props) => {
  const { subItems, hasBorder, labelWidth, updateLabelWidth, onClick, hidden } =
    props
  const theme = useTheme()

  return (
    <>
      <StyledListItem
        borderBottom={hasBorder ? `2px solid ${theme.palette.info.main}` : ""}
        onClick={onClick}
        theme={theme}
      >
        {subItems.map((item) =>
          item.separator ? (
            <div
              style={{
                borderBottom: `2px solid ${theme.palette.grey.A200}`,
                marginBlock: theme.spacing(1),
              }}
            ></div>
          ) : (
            <StyledSubListItem
              justifyContent={"flex-start"}
              key={item.label}
              gap={theme.spacing(3)}
              style={{ justifyContent: "space-between" }}
            >
              <ListTextItemLabel
                hidden={hidden}
                item={item}
                labelWidth={labelWidth}
                updateLabelWidth={updateLabelWidth}
              />
              {item.content ? (
                isValidUrl(item.content) ? (
                  <Link
                    href={`${
                      !(
                        item.content.startsWith("http://") ||
                        item.content.startsWith("https://")
                      )
                        ? "https://"
                        : ""
                    }${item.content}`}
                  >
                    {item.content}
                  </Link>
                ) : (
                  <Typography onClick={() => {}} style={{ textAlign: "right" }}>
                    {item.content}
                  </Typography>
                )
              ) : (
                <></>
              )}
            </StyledSubListItem>
          )
        )}
      </StyledListItem>
    </>
  )
}

const ListTextItemLabel = (props) => {
  const ref = useRef(null)
  const { item, labelWidth, updateLabelWidth, hidden } = props

  useEffect(() => {
    // Add 1 to make sure values rounded down are not cut off
    !hidden &&
      !labelWidth &&
      !item?.autoWidth &&
      updateLabelWidth(ref.current ? ref.current.offsetWidth + 1 : 0)
    // eslint-disable-next-line
  }, [hidden])

  return (
    <Typography
      sx={{
        fontWeight: item.hasBoldLabel ? "bold" : "normal",
        // flexBasis:
        //   !item.autoWidth && labelWidth !== null ? `${labelWidth}px` : "auto",
        flexBasis: "auto",
      }}
      variant={"body1"}
      ref={ref}
    >
      {item.label}
    </Typography>
  )
}
export default ListTextItem
